const isExist = function (key) {
  let isExist = window.localStorage.getItem(key)
  return isExist ? true : false
}
const storageUtil = {
  isExist: isExist,
  addStorage(key, value) {
    if (isExist(key)) {
      return { status: false, msg: new Error("key is already exist") }
    }
    window.localStorage.setItem(key, JSON.stringify(value))
    return { status: true, msg: undefined }
  },
  deleteStorage(key) {
    if (!isExist(key)) {
      return { status: false, msg: new Error("key is not exist") }
    }
    window.localStorage.removeItem(key)
    return { status: true, msg: undefined }
  },
  updateStorage(key, value) {
    if (!isExist(key)) {
      return { status: false, msg: new Error("key is not exist") }
    }
    window.localStorage.setItem(key, JSON.stringify(value))
    return { status: true, msg: undefined }
  },
  getStorage(key) {
    if (!isExist(key)) {
      return { status: false, msg: new Error("key is not exist") }
    }
    let result = JSON.parse(window.localStorage.getItem(key))
    return { status: true, msg: result }
  }
}
export default storageUtil